import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	allApps: {
		id: 'search.quickFind.intentRouter.allApps',
		defaultMessage: 'All apps',
	},
	jiraWorkItems: {
		id: 'search.quickFind.intentRouter.jiraWorkItems',
		defaultMessage: 'Jira work items',
	},
});
